import { render, staticRenderFns } from "./ViewLogisticTruck.vue?vue&type=template&id=4bb132a2&scoped=true"
import script from "./ViewLogisticTruck.vue?vue&type=script&lang=ts"
export * from "./ViewLogisticTruck.vue?vue&type=script&lang=ts"
import style0 from "./ViewLogisticTruck.vue?vue&type=style&index=0&id=4bb132a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb132a2",
  null
  
)

export default component.exports